import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'

export const AvailabilityLoading = ({ isLoading, children }) => isLoading ? (
  <div className='card-price col-12 mt-1 mb-1 p-0'>
    <div className='row align-items-center h-100'>
      <div className='card-price-item col-12'>
        <div className='row'>
          <div className='card-button col-12 m-0 mt-1 p-0'>
            <Button
              id={Math.random().toString()}
              loading
              className='btn-flat mx-auto py-half'
              role='button'
              aria-label='Carregando pontuação'
            >
              Carregando
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
) : children

AvailabilityLoading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
}

AvailabilityLoading.defaultProps = {
  isLoading: true
}

export default AvailabilityLoading



// WEBPACK FOOTER //
// ./src/Catalog/Availability/AvailabilityLoading.js